import { gql } from "gql";

export const GET_POST_COMMENTS = gql(/* GraphQL */ `
  query GetPostPostComments($id: ID!) {
    getPostById(id: $id) {
      comments {
        ...Comments
      }
    }
  }
`);
